<template>
  <div>
    <div v-if="communityList[0] && multipleCommunityChoice === false">
      <div
        v-if="!communityList[0].isBroadcast || owner.id === userId || isUserBroadcaster"
        class="create-post-block lined-block"
      >
        <p v-if="firstPost">
          {{ $t('post.postCreate.beTheFirstToPost') }}
        </p>
        <p v-else>
          {{ $t('post.postCreate.writeANewPostInCommunity') }}
        </p>
        <v-button data-cy="create-post-button" :on-click="create" class="create-button"
                  :border-radius="'500px'"
        >
          {{ $t('post.postCreate.writeNewPost') }}
        </v-button>
      </div>
      <div v-else class="create-post-block lined-block info-broadcast">
        <p>{{ $t('post.postCreate.broadcastPostNotAllowed') }}</p>
      </div>
    </div>
    <div v-else-if="multipleCommunityChoice === true">
      <div v-if="communityList[0]" class="create-post-block lined-block">
        <p>
          {{ $t('post.postCreate.chooseCommunityAndWritePost') }}
        </p>
        <v-button :on-click="create" class="create-button h-shadow-h"
                  :border-radius="'50px'"
        >
          {{ $t('post.postCreate.writeNewPost') }}
        </v-button>
      </div>
      <div v-else class="create-post-block lined-block">
        <p>
          {{ $t('post.postCreate.needCommunityToPost') }}
        </p>
      </div>
    </div>
    <modal
      @close="closeModal"
      class="modal"
      v-if="showModal"
      :width="'865px'"
    >
      <div slot="header" class="modal-header">
        {{ $t('post.postCreate.writeANewPost') }}
      </div>
      <post-form
        slot="body"
        :community-list="communitiesSorted"
        :multiple-community-choice="multipleCommunityChoice"
        :edit-mode="false"
        @close="closeModal"
      />
    </modal>
  </div>
</template>
<script>
import VButton from '@/components/shared/VButton'
import Modal from '@/components/shared/Modal'
import { mapState } from 'vuex'
import PostForm from '@/components/post/PostForm'

export default {
  name: 'PostCreate',
  components: { PostForm, Modal, VButton },
  props: {
    communityList: {
      type: Array,
      default: () => []
    },
    owner: {
      type: Object,
      default: () => {}
    },
    firstPost: Boolean,
    multipleCommunityChoice: Boolean
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    create() {
      this.showModal = true
    }
  },
  computed: {
    isUserBroadcaster() {
      const index = this.communityDetail.members.findIndex(m => m.id === this.userId)
      if (index < 0) {
        return false
      }
      return this.communityDetail.members[index]['communities.UserCommunity.isAllowedToPost']
    },
    communitiesSorted() {
      return this.communityList.slice().sort(function (a, b) {
        if (a.name < b.name) { return -1 }
        if (a.name > b.name) { return 1 }
        return 0
      })
    },
    ...mapState({
      userId: state => state.user.user.id,
      communityDetail: state => state.community.communityDetail
    })
  }
}
</script>
<style scoped lang="scss">
.create-post-block {
  justify-content: space-between;
  align-items: center;
  width: 606px;
  display: flex;
  flex-direction: row;

  @media (max-width: $medium) {
    width: calc(50vw - 32px);
  }

  @media (max-width: $header-change) {
    width: calc(80vw - 1rem);
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  @media (max-width: $small) {
    width: calc(100vw - 1rem);
    transition: all 0.2s ease;

  }

    .create-description {
    align-content: center;
  }

  p {
    margin: 16px 24px;
  }
}

.create-button {
  margin: 22px 24px 22px 10px;
}

.lined-block {
  background: #ffffff;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
  border-radius: 3px;
  margin: 1rem;
  border-top: solid 2px $secondary-color;
  text-align: left;
  color: $black-color;
  letter-spacing: 0;
  line-height: 24px;
}

.info-broadcast {
  border-top: 0;
}
</style>
